<template>
	<div class='matters-wrap'>
		<div class="nav-wrap">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="/server/administrat_find">行政许可/行政处罚查询</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" to="/mattersDirectory" replace>事项目录</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" :to="`/mattersDetail?name=${name}`" replace><span>{{name}}</span></router-link>
			</div>
		</div>
		<div class="matters-main">
			<div class="flex matters-tab">
				<div class="" v-for="item in tabList" :key="item.name" :class="{active: item.name===tabId}" @click="tabHandler(item.name)">{{item.name}}</div>
			</div>

			<ul class="matters-list">
				<li class="flex flex-row-between masters-header">
					<p>序号</p>
					<p>项目名称</p>
					<p>行政相对人</p>
					<p>设定依据</p>
				</li>
				<empty v-if="!list.length" />

				<li class="flex flex-row-between" v-for="(item, index) in list" :key="item.id">
					<p>{{index+1}}</p>
					<p class="ellipsis-2">{{item.name}}</p>
					<p class="ellipsis-2">{{item.name}}</p>
					<p class="ellipsis-2">{{item.content}}</p>
				</li>
			</ul>
			<div class="flex flex-row-end " v-if="list.length>0">
				<el-pagination background layout="total, prev, pager, next" :pageSize="pageSize" :total="total" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { bothPublic } from '@/api';
import empty from '@/components/empty'
export default {
	components: {
		empty
	},
	data() {
		return {
			name: undefined,
			tabId: '行政许可',
			list: [],
			pageSize: 15,
			total: 0,
			tabList: [
				{ name: '行政许可', },
				{ name: '行政处罚' }]
		}
	},
	created() {
		const { query: { name, id } } = this.$route;
		this.$set(this, 'name', name)
	},
	mounted() {
		this.getList()
	},
	methods: {
		tabHandler(name) {
			if (name !== this.tabId) {
				this.$set(this, 'tabId', name);
				this.getList(1)
			}
		},
		getList(page = 1) {
			const { query: { id } } = this.$route;

			const params = {
				current: page,
				orgIds: id
			};

			params.types = this.tabId === '行政许可' ? '1,2' : '3,4';
			bothPublic(params).then(res => {
				this.setTableData(res);
			})
		},
		setTableData(response) {
			const { records, size, current, total } = response;
			this.$set(this, 'total', total || 0);
			this.$set(this, 'pageSize', size || 15);
			this.$set(this, 'list', records || []);
		},
		handleCurrentChange(e) {
			this.getList(e)
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.matters-wrap {
		padding-bottom: 20px;
		& > .matters-main {
			width: 1280px;
			margin: 0 auto;
			padding-top: 20px;
			& > .matters-tab {
				& > div {
					font-size: 18px;
					color: #202123;
					vertical-align: top;
					width: 158px;
					height: 58px;
					line-height: 48px;
					text-align: center;
					padding-top: 10px;
					border-bottom: 4px solid #f8f9fb;
					cursor: pointer;
					&.active {
						color: $red;
						border-color: $red;
					}
				}
			}
			& > .matters-list {
				& > li {
					height: 50px;
					line-height: 50px;
					color: #0f1316;
					font-size: 16px;
					&:nth-child(even) {
						background-color: #fff;
					}
					&.masters-header {
						background: #c0c4c7;
					}
					& > p {
						text-align: center;
						flex-basis: 320px;
						&:nth-child(3) {
							flex-basis: 422px;
						}
						&:first-of-type {
							flex-basis: 170px;
						}
						&:not(:first-of-type) {
							line-height: 25px;
						}
					}
				}
			}
			& > .pagination-wrap {
				margin-top: 20px;
			}
		}
	}
</style>